export type Locale = "fr" | "en" | "nl";
export const LOCALES: Locale[] = ["fr", "en", "nl"];
export const DEFAULT_LOCALE: Locale = "fr";
export const LOCALE_LABELS: Record<Locale, string> = {
  fr: "Français",
  en: "English",
  nl: "Nederlands",
};
export const COOKIE_NAME = "symmetria.locale";
